module.exports = __webpack_public_path__ + "static/mmj-logo-6edfb2b0cbd6062ca433a7d23d525843.png";